<template>
    <PageFull header="Счет" type="white" :fullwidth="true" :nopadding="false">
        <template v-slot:body>
            <div class="w-full px-0">                 
                <div v-if="account" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row" >
                    <div class="w-full flex flex-column gap-3">
                        <div v-if="account" class="w-full flex flex-column gap-0">
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Account ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ account.id }}
                                    </span>
                                </span>...
                                <Button @click="copy(account.id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Wallet ID: 
                                </span>
                                <span class="flex my-auto overflow-hidden" style="max-width:10em">
                                    <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                        {{ account.wallet_id }}
                                    </span>
                                </span>...
                                <Button @click="copy(account.wallet_id)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div>
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Валюта: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ account.currency }}
                                </span>
                                <Button @click="copy(account.currency)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                            <div class="flex flex-row gap-1 text-sm vertical-align-middle justify-content-start align-items-center">
                                <span class="font-medium">
                                    Баланс: 
                                </span>
                                <span class="flex my-auto overflow-hidden uppercase">
                                    {{ get_format_amount(account.balance, account.currency, 2) }} ({{ account.balance }} {{ account.currency }})
                                </span>
                                <Button @click="copy(account.balance)" icon="pi pi-copy" iconPos="right" size="small" outlined severity="secondary" class="border-0" />
                            </div> 
                        </div>

                        <div v-if="account" class="flex flex-row">
                            <Topup v-if="account.wallet_id && isUserInGroup('admin_accounts_billing', accessCodes)" 
                                :wallet_id="account.wallet_id" :currency="account.currency" :account="account" />
                        </div>

                        <SelectButton v-model="option" :options="options" optionLabel="label" optionValue="value" aria-labelledby="basic" class="flex text-sm">
                            <template #option="slotProps">
                                <span class="text-xs py-0 white-space-nowrap">{{ slotProps.option.label }}</span>
                            </template>
                        </SelectButton>

                        <div v-if='isUserInGroup("admin_transactions", accessCodes) && option === "tx"' 
                            class="w-full flex flex-column gap-2">
                            <TransactionsList v-if='transactions && transactions.length > 0'
                                :transactions="transactions" :total="totalTrans" :account_id="account_id" :loading="loading"
                                @filter="setFilter" @lazyParams="setParams" :defaultParams="lazyParams"/> 
                            <span v-else-if="transactions && transactions.length === 0">Нет транзакций</span>
                        </div>

                        <div v-if='isUserInGroup("admin_operations", accessCodes) && option === "op"' 
                            class="w-full flex flex-column gap-2">
                            <OperationsList v-if='operations && operations.length > 0' 
                                :operations="operations" :totalRecords="totalOps" :loading="loading"
                                @onFilter="setFilter" 
                                @onPageChange="setParams" 
                                :defaultParams="lazyParams"/>
                            <Skeleton height="2rem" v-else />
                            <span v-if="!loading && operations && operations.length === 0">Нет операций</span>
                        </div>
                        
                    </div>
                </div>
                <Skeleton height="2rem" v-else />
            </div>
        </template>
    </PageFull>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import { useRoute } from 'vue-router'
import PageFull from '@/components/public/page.vue'
import TransactionsList from '@/components/admin/transaction/list.vue'
import OperationsList from '@/components/admin/operation/list.vue'
import Topup from '@/components/admin/account/topup.vue'

export default {
    data() {
        return {
            account_id: null,
            account: null,
            transactions: [],
            operations: [],
            loading: false,
            lazyParams: {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            },
            totalTrans: 0,
            totalOps: 0,
            options: [
                {
                    value: 'tx',
                    label: 'Транзакции',
                },
                {
                    value: 'op',
                    label: 'Операции',
                },
            ],
            option: 'tx',
        }
    },
    components: {
        PageFull,
        TransactionsList,
        OperationsList,
        Topup
    },
    computed: {
        accessCodes: function () { return this.$store.getters.StateUserAccessCodes },
    },
    watch: {
        option(newVal) {
            if(newVal === 'tx' && this.transactions.length === 0) {
                this.GetAccount()
            } else if(newVal === 'op' && this.operations.length === 0) {
                this.GetOperations()
            }
        }
    },
    methods: {
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        isUserInGroup(user, group) {
            return this.helper.isUserInGroup(user, group)
        },
        get_format_amount(value, currency, digits=2) {
            return this.helper.format_amount(value, currency, digits)
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.GetAccount();
        },
        setParams(params) {
            this.lazyParams = params
            this.GetAccount()
        },
        getClassByLabel(label){
            return this.helper.GetClassByLabel(label)
        },
        GetWalletNameByLabel(label){
            return this.helper.GetWalletNameByLabel(label)
        },
        async GetAccount() {
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
                const account_data = await this.connect.GetAdminAccount(this.account_id, this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res=>res)
                if(account_data.result) {
                    this.account = account_data.data.account
                    this.transactions = account_data.data.transactions
                    this.totalTrans = account_data.data.total
                }
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        async GetOperations() {
            if(!this.account_id) return
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' }) //скролл вверх
                const ops = await this.connect.GetAdminOperationsByAccount(this.account_id, this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, this.lazyParams.sort).then(res => res)
                console.log(ops)
                if (ops.result && ops.data) {
                    if (ops.result && ops.data.length > 0) this.operations = ops.data
                    else this.operations = []
                }
                this.totalOps = (ops.total) ? ops.total : 0
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },
        clear(){
            this.lazyParams = {
                first: 0,
                rows: 20,
                sort: null,
                sortField: null,
                sortOrder: null,
                filters: {},
            }
            this.GetAccount()
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)){
            this.account_id = route.params.id
            this.GetAccount()
            // this.GetOperations()
        } else {
            this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Неверный ID счета', life: 3000 });
            this.account = null
            this.transactions = []
            this.totalTrans = 0
        }
    },
}
</script>